import { render, staticRenderFns } from "./TableBuyerPending.vue?vue&type=template&id=d20bfb80&"
import script from "./TableBuyerPending.vue?vue&type=script&lang=ts&"
export * from "./TableBuyerPending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports